module.exports = __webpack_public_path__ + "img/chat-manage-customer-active.8171ecd2.svg";